
import {defineComponent, ref, onMounted, computed, watch, reactive} from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import AddIntegrationModal from "@/components/modals/forms/AddIntegrationModal.vue";
import DeleteModal from "@/components/modals/forms/DeleteModal.vue";
import { MenuComponent } from "@/assets/ts/components";
import {Client, Integration, Thirdparty, UaProject} from "@/store/modules/ApiModule";
import {useStore} from "vuex";
import {Actions} from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "integrations-listing",
  components: {
    Datatable,
    AddIntegrationModal,
    DeleteModal
  },
  setup() {
    const tableHeader = ref([
      {
        name: "User",
        key: "user",
        sortable: true,
      },
      {
        name: "Platform",
        key: "thirdparty",
        sortable: true,
      },
      {
        name: "Status",
        key: "status",
        sortable: true,
      },
      {
        name: "Error",
        key: "error",
        sortable: false,
      },
      {
        name: "Actions",
        key: "actions",
      },
    ]);

    const store = useStore();
    let myIntegrations = ref<Array<Integration>>([]);
    let selectedItem = reactive({} as Integration);

    let myData = computed(() => {
      return store.state.api.integrations;
    });

    const setSelectedItem = (item) => {
      if(item == null){
        Object.assign(selectedItem, {
          id: 0, thirdparty_id: 1, user: "", password: "", status: "", data: {}, two_factor_code: "", error: "", thirdparty: {} as Thirdparty
        });
      }
      else {
        Object.assign(selectedItem, item);
      }
    }

    onMounted(() => {
      MenuComponent.reinitialization();
      store.dispatch(Actions.LOAD_INTEGRATIONS);
    });

    watch(myData, (newValue, oldValue) => {
      myIntegrations.value.splice(0,myIntegrations.value.length)
      newValue.forEach(function (value) {
        myIntegrations.value.push(value);
      });
    });

    const search = ref<string>("");
    const searchItems = () => {
      /*tableData.value.splice(0, tableData.value.length, ...initClients.value);
      if (search.value !== "") {
        let results: Array<Client> = [];
        for (let j = 0; j < tableData.value.length; j++) {
          if (searchingFunc(tableData.value[j], search.value)) {
            results.push(tableData.value[j]);
          }
        }
        tableData.value.splice(0, tableData.value.length, ...results);
      }*/
    };

    const searchingFunc = (obj, value): boolean => {
      for (let key in obj) {
        if (!Number.isInteger(obj[key]) && !(typeof obj[key] === "object")) {
          if (obj[key].indexOf(value) != -1) {
            return true;
          }
        }
      }
      return false;
    };

    return {
      myData,
      myIntegrations,
      selectedItem,
      setSelectedItem,
      tableHeader,
      search,
      searchItems
    };
  },
});
